import { createContext, useContext, useState, type ReactNode } from 'react'
import { useAuth } from './AuthContext'

interface EditModeContextValue {
  isEditMode: boolean
  toggleEditMode: () => void
  canEdit: boolean
}

const EditModeContext = createContext<EditModeContextValue | undefined>(undefined)

export function EditModeProvider({ children }: { children: ReactNode }) {
  const { profile, isSuperProf } = useAuth()
  const [isEditMode, setIsEditMode] = useState(false)

  const canEdit = isSuperProf || profile?.role === 'admin'

  const toggleEditMode = () => {
    if (!canEdit) return
    setIsEditMode(prev => !prev)
  }

  return (
    <EditModeContext.Provider value={{ isEditMode: isEditMode && canEdit, toggleEditMode, canEdit }}>
      {children}
    </EditModeContext.Provider>
  )
}

export function useEditMode() {
  const ctx = useContext(EditModeContext)
  if (!ctx) throw new Error('useEditMode must be used within EditModeProvider')
  return ctx
}
